import {
  validateEmail,
  validateFieldForRequired,
  validateFieldForDob
} from 'libs/validator';
import { validatePasswordSubscriptionActivate } from 'libs/subscriptionActivate';

export const USER_INFO_KEYS = {
  EMAIL: 'email',
  PASSWORD: 'password',
  RESET_EMAIL: 'resetEmail',
  FIRST_NAME: 'given_name',
  LAST_NAME: 'family_name',
  DOB: 'birthdate',
  ACCESS_TOKEN: 'accessToken'
};

export const ERROR_INFO_KEYS = {
  AUTH_FORM: 'authForm',
  RESET_EMAIL_FORM: 'resetEmailForm'
};

export const AUTH_FORM_ADDITIONAL_INFO_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [
    USER_INFO_KEYS.FIRST_NAME,
    USER_INFO_KEYS.LAST_NAME,
    USER_INFO_KEYS.DOB
  ]
};

export const AUTH_FORM_LOGIN_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [USER_INFO_KEYS.EMAIL, USER_INFO_KEYS.PASSWORD]
};

export const AUTH_FORM_SIGNUP_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.AUTH_FORM,
  errorFields: [
    USER_INFO_KEYS.EMAIL,
    USER_INFO_KEYS.PASSWORD,
    USER_INFO_KEYS.FIRST_NAME,
    USER_INFO_KEYS.LAST_NAME,
    USER_INFO_KEYS.DOB
  ]
};

export const RESET_EMAIL_ERROR_CONFIG = {
  errorKey: ERROR_INFO_KEYS.RESET_EMAIL_FORM,
  errorFields: [USER_INFO_KEYS.RESET_EMAIL]
};

export function checkErrors(errorFields = [], userInfo = {}, isSignup = false) {
  const errors = {};

  if (errorFields.indexOf(USER_INFO_KEYS.FIRST_NAME) !== -1) {
    const firstNameError = validateFieldForRequired(
      userInfo[USER_INFO_KEYS.FIRST_NAME]
    );
    if (firstNameError) {
      errors[USER_INFO_KEYS.FIRST_NAME] = firstNameError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.LAST_NAME) !== -1) {
    const lastNameError = validateFieldForRequired(
      userInfo[USER_INFO_KEYS.LAST_NAME]
    );
    if (lastNameError) {
      errors[USER_INFO_KEYS.LAST_NAME] = lastNameError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.EMAIL) !== -1) {
    const emailError = validateEmail(userInfo[USER_INFO_KEYS.EMAIL]);
    if (emailError) {
      errors[USER_INFO_KEYS.EMAIL] = emailError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.PASSWORD) !== -1) {
    const passwordError = isSignup ?
      validatePasswordSubscriptionActivate(userInfo[USER_INFO_KEYS.PASSWORD]) :
      validateFieldForRequired(userInfo[USER_INFO_KEYS.PASSWORD]);
    if (passwordError) {
      errors[USER_INFO_KEYS.PASSWORD] = passwordError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.RESET_EMAIL) !== -1) {
    const resetEmailError = validateEmail(userInfo[USER_INFO_KEYS.RESET_EMAIL]);
    if (resetEmailError) {
      errors[USER_INFO_KEYS.RESET_EMAIL] = resetEmailError;
    }
  }

  if (errorFields.indexOf(USER_INFO_KEYS.DOB) !== -1) {
    const dob = userInfo[USER_INFO_KEYS.DOB];
    const dobError = validateFieldForDob(dob);
    if (dobError) {
      errors[USER_INFO_KEYS.DOB] = dobError;
    }
  }

  return errors;
}

export default {
  USER_INFO_KEYS
};



// WEBPACK FOOTER //
// ./src/views/SubscriptionActivate/AccountDetails/config.js